/**
 * Shared helper for Interoperability mock services.
 *
 * There is no established "mock service" convention elsewhere in this
 * repository (every other feature module calls a real backend API). Since
 * Interoperability has no backend yet, each service below implements typed
 * in-memory CRUD behind an async function signature so a real API client
 * can be swapped in later with no changes required in consuming components.
 */

/** Small artificial delay so `loading` states have something to render. */
export function mockDelay(ms = 200): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

let idCounter = 0;

/** Deterministic, stable mock ID generator (not a real UUID). */
export function nextMockId(prefix: string): string {
  idCounter += 1;
  return `${prefix}-${idCounter}`;
}
